module.exports = __webpack_public_path__ + "img/acc-wb.e97afc80.png";